module.exports = "<div class=\"oly-button\" ng-class=\"buttonClass\">\r\n    <div class=\"_oly-button-transclude\" ng-show=\"!loading.state\"></div>\r\n    <div ng-show=\"loading.state\" class=\"oly-button-loading _oly-button-loading {{ btnClass }}\" tabindex=\"0\">\r\n        <wow-loading-spinner ng-if=\"loading.state\" sr-message=\"{{ loading.message }}\" class=\"{{ spinnerClass }}\"></wow-loading-spinner>\r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/button/button-template.html
 ** module id = 843
 ** module chunks = 2
 **/